export enum TypeOfStroke {
  Ischemic = 'Ischemic',
  Hemorrhagic = 'Hemorrhagic',
  TIA = 'TIA',
  BrainStemStroke = 'Brain stem stroke',
}
